(function () {
  const btn = document.getElementById('BackToTop');
  if (!btn) return;

  // Retire l'attribut hidden pour activer les transitions CSS
  btn.removeAttribute('hidden');

  // Seuil d'apparition : 400px de scroll
  const SCROLL_THRESHOLD = 400;

  let ticking = false;

  function updateButton() {
    const scrollY = window.scrollY || window.pageYOffset;

    if (scrollY > SCROLL_THRESHOLD) {
      btn.classList.add('is-visible');
    } else {
      btn.classList.remove('is-visible');
    }

    ticking = false;
  }

  function onScroll() {
    if (!ticking) {
      window.requestAnimationFrame(updateButton);
      ticking = true;
    }
  }

  // Listener scroll avec throttle via requestAnimationFrame
  window.addEventListener('scroll', onScroll, { passive: true });

  // Vérification initiale (au cas où la page est déjà scrollée au load)
  updateButton();

  // Click handler : scroll fluide vers le haut
  btn.addEventListener('click', function () {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  });
})();